export type ProductFiltersMessages = {
  filterByLabel: string;
  statusOption: string;
  skuStatusOption: string;
  statusTrueOption: string;
  statusFalseOption: string;
  codeOption: string;
  externalReferenceOption: string;
  titleOption: string;
  skuCodeOption: string;
  skuEanOption: string;
  shortDescriptionOption: string;
  descriptionOption: string;
  brandOption: string;
  ncmOption: string;
  kitOption: string;
  kitTrueOption: string;
  kitFalseOption: string;
  selectKitPlaceholder: string;
  hasPhotoOption: string;
  hasPhotoTrueOption: string;
  hasPhotoFalseOption: string;
  selectHasPhotoPlaceholder: string;
  categoryOption: string;
  valueLabel: string;
  search: string;
  allOption: string;
  moreFiltersButton: string;
  lessFiltersButton: string;
  clearFilterButton: string;
  filterButton: string;
  selectStatusPlaceholder: string;
  selectSkuStatusPlaceholder: string;
  errorRequiredFilterBy: string;
  errorRequiredFilterValue: string;

  filterPromptTitle: string;
  filterPromptDescription: string;
  filterPromptAlt: string;
};

export const PRODUCT_FILTERS_MESSAGES: ProductFiltersMessages = {
  filterByLabel: "Filtrar por",
  statusTrueOption: "Sim",
  brandOption: "Marca",
  codeOption: "Código",
  descriptionOption: "Descrição",
  shortDescriptionOption: "Descrição curta",
  statusFalseOption: "Não",
  externalReferenceOption: "Referência externa",
  kitOption: "É Kit",
  kitTrueOption: "Sim",
  kitFalseOption: "Não",
  selectKitPlaceholder: "Todos",
  hasPhotoOption: "Contém foto",
  hasPhotoTrueOption: "Sim",
  hasPhotoFalseOption: "Não",
  selectHasPhotoPlaceholder: "Todos",
  categoryOption: "Categoria",
  ncmOption: "NCM",
  statusOption: "Produto Ativo",
  skuStatusOption: "Sku Ativo",
  titleOption: "Nome do produto",
  skuCodeOption: "Código do sku",
  skuEanOption: "EAN",
  valueLabel: "Valor",
  search: "Buscar",
  allOption: "Todos",
  moreFiltersButton: "Mais filtros",
  lessFiltersButton: "Menos filtros",
  clearFilterButton: "Limpar filtros",
  filterButton: "Filtrar",
  selectStatusPlaceholder: "Todos",
  selectSkuStatusPlaceholder: "Todos",
  errorRequiredFilterBy: "Esse campo é obrigatório!",
  errorRequiredFilterValue: "Esse campo é obrigatório!",
  filterPromptTitle: "Nenhum produto exibido",
  filterPromptDescription:
    "Use os filtros acima e clique em Filtrar para exibir os produtos que deseja consultar.",
  filterPromptAlt: "Aplique filtros para exibir produtos",
};
